module.exports = __webpack_public_path__ + "img/mastercard.dcf68410.svg";